import React, {FC} from 'react'
import {UseFormRegister, FieldErrors} from 'react-hook-form'

type InputProps = {
  type?: string
  name: string
  textPlaceholder: string
  register: UseFormRegister<any>
  errors: FieldErrors
  maxLength?: number
  minLength?: number
  caracteresTel?: boolean // Prop para habilitar o deshabilitar la validación de caracteres
  disabled?: boolean | undefined
}

const InputNumber: FC<InputProps> = ({
  type = 'text',
  name,
  textPlaceholder,
  register,
  maxLength = 9999,
  minLength = 0,
  errors,
  disabled = false,
  caracteresTel = false,
  ...props
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    let regex = caracteresTel ? /^[\d+\-()]*$/ : /^\d$/

    if (!regex.test(e.key) && e.keyCode !== 8) {
      e.preventDefault()
    }
  }

  return (
    <div className='sdx_form_input'>
      {/* <Controller
        name={name} // Nombre del campo en el formulario y debe coincidir con el nombre en el esquema de validación
        control={control} // Proporciona el objeto 'control' de react-hook-form
        render={({ field }) => (
          <input
            {...field}
            type="text"
            className='form-control sdx-centra-input-form'
            placeholder={textPlaceholder}
            maxLength={maxLength}
            onKeyPress={handleKeyPress}
            disabled={disabled}
          />
        )}
      /> */}

      <input
        type={type}
        className='form-control sdx-centra-input-form'
        placeholder={textPlaceholder}
        maxLength={maxLength}
        onKeyPress={handleKeyPress}
        disabled={disabled}
        {...register(name)}
        // pattern="^[A-Z\s]*$"
        {...props}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputNumber
